export enum PackingStatusType {
    NotPacked = "NotPacked",
    InProcess = "InProcess",
    Packed = "Packed"
}

